// extracted by mini-css-extract-plugin
export default {"container":"RecordMetaData_container__mmS0l","item":"RecordMetaData_item__DzCj9"};